import { Component, Inject, OnInit } from '@angular/core';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { SharedService } from '../../core/services/shared.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModuleAccess } from '../../../../../dispatch-board/src/app/components/dispatch-board/dispatch-board.interface';
import _ from 'lodash';
import { NgxTippyService } from 'ngx-tippy-wrapper';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';

@Component({
  selector: 'app-calendar-settings',
  templateUrl: './calendar-settings.component.html',
  styleUrls: ['./calendar-settings.component.scss']
})
export class CalendarSettingsComponent implements OnInit {
  moduleName: string;
  isLoading: boolean = false;
  defaultGridModuleValue: any;
  tableViewDefaultAttributeKeys: any[] = ['work_order_number@Job-#', 'work_order_title@Job-Title'];
  isOptionsAvailable: boolean = false;
  customSelectedAttributes: any = [];
  moduleFormMap = {'calendar': this._sharedService.calendarForm,'general': this._sharedService.calendarForm};
  constructor(private _localisationService: LocalisationService,
    public _sharedService: SharedService,
    private _localStorageService: LocalStorageService,
    public dialogRef: MatDialogRef<CalendarSettingsComponent>,
    public _utilityService: UtilityService,
    public _tippyService: NgxTippyService,
    @Inject(MAT_DIALOG_DATA) public dialogData) { }

  ngOnInit(): void {
    this.isLoading = true;
    this._localisationService.setDefaultLanguage();
    this.moduleName = 'CALENDAR';
    this.defaultGridModuleValue = this._localStorageService.getLocalStorage('calendar_metadata');
    if (this.defaultGridModuleValue !== undefined) {
      this._sharedService.calendarForm.patchValue(this.defaultGridModuleValue?.calendar);
    }
    this._sharedService.defaultGridModuleValue = this.defaultGridModuleValue;
    this._sharedService.newToCalendar = this.dialogData?.data.newToCalendar || false;
    this._sharedService.getJobAttributes().then(() => {
      this.isLoading = false;
      this.isOptionsAvailable = true;
    });
  }

  closeSettingsDialog(): void {
    this._sharedService.settingsDialogInstance.close();
  }

  onSubmit(): void {
    this._sharedService.saveMetaData();
  }

  disableSubmit(): any {
    const monthViewData = this._sharedService.calendarForm.value?.month_card_view;
    return this._utilityService.isEmptyOrUndefined(monthViewData);
  }

  onTabChange(selectedTab: string): void {
    this.moduleName = selectedTab;
    this.setScrollToTop();
  }

  setScrollToTop(): void {
    const scrollHandlerElements: HTMLCollection = document.getElementsByClassName('scrollHandler');
    if (scrollHandlerElements.length > 0) {
      for (const scrollHandlerElement of scrollHandlerElements) {
        scrollHandlerElement.scrollIntoView();
      }
    }
  }

}
